/**
 * https://caniuse.com/?search=URLSearchParams
 * IE11 is not supported
 * (need to test with it, if we are supporting it)
 */

import queryString from "query-string";
import { useCallback } from "react";

const buildUrl = (params) =>
  `${window.location.pathname}?${queryString.stringify(params)}${
    window.location.hash
  }`;

export const useQueryString = () => {
  const getAllItems = useCallback(() => {
    const parsed = queryString.parse(window.location.search);
    return parsed;
  }, []);

  const getItem = useCallback((param, defaultValue = undefined) => {
    const params = getAllItems();
    return params[param] || defaultValue;
  }, []);

  const setItem = useCallback((param, value) => {
    const params = getAllItems();
    params[param] = value;

    history.pushState(null, "", buildUrl(params));
  }, []);

  const removeItem = useCallback((param) => {
    const params = getAllItems();
    const newParams = Object.keys(params).reduce((acc, key) => {
      if (key !== param) {
        acc[key] = params[key];
      }
      return acc;
    }, {});

    history.pushState(null, "", buildUrl(newParams));
  }, []);

  return {
    getAllItems,
    getItem,
    setItem,
    removeItem
  };
};
